module.exports = __webpack_public_path__ + "a296ef66d52039dc5a41adcd417167f5.svg";